var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialAnxiety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173.599,
    height: 152.481,
    viewBox: "0 0 173.599 152.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3366.627739 8749.098243 C 3366.627739 8679.918261 3422.755633 8623.711976 3492.014006 8623.711976 C 3561.272379 8623.711976 3617.439469 8679.918261 3617.439469 8749.098243 C 3617.439469 8818.395811 3561.272379 8874.484511 3492.014006 8874.484511 C 3422.755633 8874.484511 3366.627739 8818.395811 3366.627739 8749.098243 Z M 3366.627739 8749.098243 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3375.681889 8531.798629 L 3608.346123 8531.798629 C 3677.761278 8531.798629 3734.045954 8475.513952 3734.045954 8406.098798 L 3734.045954 8289.609899 C 3734.045954 8276.792985 3723.659158 8266.406189 3710.803048 8266.406189 L 3273.26416 8266.406189 C 3260.40805 8266.406189 3250.021254 8276.792985 3250.021254 8289.609899 L 3250.021254 8406.098798 C 3250.021254 8475.513952 3306.30593 8531.798629 3375.681889 8531.798629 Z M 3375.681889 8531.798629 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2858.615419 9053.215795 C 2858.615419 8983.918227 2914.782509 8927.790332 2984.040882 8927.790332 C 3053.299254 8927.790332 3109.466344 8983.918227 3109.466344 9053.215795 C 3109.466344 9122.513363 3053.299254 9178.602063 2984.040882 9178.602063 C 2914.782509 9178.602063 2858.615419 9122.513363 2858.615419 9053.215795 Z M 2858.615419 9053.215795 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2867.708765 8835.916181 L 3100.372998 8835.916181 C 3169.788153 8835.916181 3226.033634 8779.592309 3226.033634 8710.21635 L 3226.033634 8593.688256 C 3226.033634 8580.910537 3215.646838 8570.484545 3202.829923 8570.484545 L 2765.25184 8570.484545 C 2752.434925 8570.484545 2742.048129 8580.910537 2742.048129 8593.688256 L 2742.048129 8710.21635 C 2742.048129 8779.592309 2798.29361 8835.916181 2867.708765 8835.916181 Z M 2867.708765 8835.916181 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4125.412594 9053.215795 C 4125.412594 8983.918227 4069.284699 8927.790332 4000.026326 8927.790332 C 3930.767953 8927.790332 3874.600863 8983.918227 3874.600863 9053.215795 C 3874.600863 9122.513363 3930.767953 9178.602063 4000.026326 9178.602063 C 4069.284699 9178.602063 4125.412594 9122.513363 4125.412594 9053.215795 Z M 4125.412594 9053.215795 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4116.358443 8835.916181 L 3883.694209 8835.916181 C 3814.279055 8835.916181 3757.994378 8779.592309 3757.994378 8710.21635 L 3757.994378 8593.688256 C 3757.994378 8580.910537 3768.381174 8570.484545 3781.237284 8570.484545 L 4218.815368 8570.484545 C 4231.632282 8570.484545 4242.019078 8580.910537 4242.019078 8593.688256 L 4242.019078 8710.21635 C 4242.019078 8779.592309 4185.773597 8835.916181 4116.358443 8835.916181 Z M 4116.358443 8835.916181 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3366.627739 9247.782044 C 3366.627739 9178.484476 3422.755633 9122.395777 3492.014006 9122.395777 C 3561.272379 9122.395777 3617.439469 9178.484476 3617.439469 9247.782044 C 3617.439469 9317.001222 3561.272379 9373.207507 3492.014006 9373.207507 C 3422.755633 9373.207507 3366.627739 9317.001222 3366.627739 9247.782044 Z M 3366.627739 9247.782044 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3048.517409 9432.706211 C 3048.517409 9363.487034 3104.684499 9307.280748 3173.942871 9307.280748 C 3243.201244 9307.280748 3299.368334 9363.487034 3299.368334 9432.706211 C 3299.368334 9502.003779 3243.201244 9558.210065 3173.942871 9558.210065 C 3104.684499 9558.210065 3048.517409 9502.003779 3048.517409 9432.706211 Z M 3048.517409 9432.706211 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3935.510604 9432.706211 C 3935.510604 9363.487034 3879.382709 9307.280748 3810.124336 9307.280748 C 3740.865964 9307.280748 3684.698873 9363.487034 3684.698873 9432.706211 C 3684.698873 9502.003779 3740.865964 9558.210065 3810.124336 9558.210065 C 3879.382709 9558.210065 3935.510604 9502.003779 3935.510604 9432.706211 Z M 3935.510604 9432.706211 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#805aed",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3250.021254 8881.618084 C 3250.021254 8950.994043 3306.30593 9007.200328 3375.681889 9007.200328 L 3608.346123 9007.200328 C 3677.761278 9007.200328 3734.045954 8950.994043 3734.045954 8881.618084 ",
    transform: "matrix(0.0996608, 0, 0, -0.0996608, -261.173105, 964.328712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialAnxiety);
export default __webpack_public_path__ + "static/media/social-anxiety.bc913de15534b9d3e1744ba7808f6eed.svg";
export { ForwardRef as ReactComponent };